import { render, staticRenderFns } from "./vulnerabilities.vue?vue&type=template&id=45dcb01d&scoped=true"
import script from "./vulnerabilities.vue?vue&type=script&lang=js"
export * from "./vulnerabilities.vue?vue&type=script&lang=js"
import style0 from "./vulnerabilities.vue?vue&type=style&index=0&id=45dcb01d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dcb01d",
  null
  
)

export default component.exports